import { Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React from "react"
import { getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils"

const DeleteModal = ({ deleteModalState, onDeleteClick, onCloseClick, textMessage, cancelButton, headerIcon = "mdi-delete", disableDeleteButton = false }) => {
  return (
    <Modal isOpen={deleteModalState.action} toggle={onCloseClick} centered={true}>
      <ModalHeader>
        <div className="d-flex justify-content-center">
          <i className={`align-self-bottom label-title bx mdi ${headerIcon} ${getPrimaryTextClass()} me-1`}></i>
          <span className="modal-title call-transcription-topic-heading">
          {textMessage.DELETE_TEXT_HEADING}
          </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody className="noscrollbar">
        <Row>
          <Col xl={12}>
            <div className="mb-3">
              <Label className="form-label mb-3 ">
                {textMessage.DELETE_TEXT_MESSAGE}
              </Label>
            </div>
          </Col>
        </Row>
      </ModalBody>
      {(!disableDeleteButton || cancelButton) && 
        <ModalFooter>
          {disableDeleteButton ? null :
            <button
              type="button"
              className={`btn ${getPrimaryButtonClass()} ms-2`}
              onClick={() => onDeleteClick(deleteModalState)}
            >
              {textMessage.DELETE_TEXT_CTA}
            </button>
          }
          {cancelButton? 
          <button
            type="button"
            className="btn btn-light ms-2"
            onClick={onCloseClick}
          >
            Cancel
          </button> : null }
        </ModalFooter>
      }
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  deleteModalState: PropTypes.any,
  textMessage: PropTypes.object,
  cancelButton: PropTypes.bool,
  disableDeleteButton: PropTypes.bool
}

export default DeleteModal
